import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA] text-[#0F172A]">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-10 sm:py-14">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-[#64748B] hover:text-[#0F172A] text-sm mb-8 transition-colors"
          data-testid="legal-back-link"
        >
          <ArrowLeft size={14} /> Back to rsell ai
        </Link>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#0F172A] tracking-tight">{title}</h1>
        <div className="text-[#94A3B8] text-xs uppercase tracking-widest mt-2 mb-8">Last updated · {updated}</div>
        <div className="prose-legal space-y-5 text-[15px] leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

// Simple heading + paragraph helpers so the page stays visually calm.
export const H2 = ({ children }) => (
  <h2 className="font-display text-[#0F172A] text-xl font-semibold mt-8 mb-3">{children}</h2>
);
export const P = ({ children }) => <p className="text-[#334155]">{children}</p>;
export const UL = ({ children }) => <ul className="list-disc pl-6 space-y-1.5 text-[#334155]">{children}</ul>;
